import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=5ca56f7a&scoped=true"
import script from "./Period.vue?vue&type=script&lang=js"
export * from "./Period.vue?vue&type=script&lang=js"
import style0 from "./Period.vue?vue&type=style&index=0&id=5ca56f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca56f7a",
  null
  
)

export default component.exports